import ReactStrapTable from 'components/reactStrapTable';
import React, { useState } from 'react';
import { cloneDeep } from 'lodash';
import ViewReports from '../ViewReports';
import Download from 'assets/icon/Download.svg';
import DownloadHover from "assets/icon/download_hoverIcon.svg";
import HoverImage from 'react-hover-image/build';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import { onExport } from 'utils/helper';
import useContextService from 'hooks/useContextService';
import { toast } from 'react-toastify'
import useAxios from 'hooks/useAxios';
import collapse from 'assets/icon/collapse-icon.svg';
import collapseclose from 'assets/icon/collapse-icon-close.svg';
import Filters from 'components/Filters';
import Autosend from 'assets/icon/Autosend-reports-icon.svg';
import AutosendHover from "assets/icon/Esp-download-hover-icon.svg";
import viewIcon from 'assets/icon/view-icon.svg';
import viewHoverIcon from 'assets/icon/view-Hover-icon.svg';


let tableDataBackup = [];

const ReportsTable = (props) => {

    const {
        manvalConfigedit,
        sort,
        setSort,
        manvalConfig,
        manvalPharmacy,
        collapseSider,
        manval,
        reportsdata,
        filters,
        totalSize,
        onPageChange,
        onSearch,
        setFilterShow,
        filtershow,
        selectedValues,
        setSelectedValues = { setSelectedValues },
        reportStartPage,
        setReportStartPage,
        fetchReports,
        ceid, 
        appid
    } = props;

    const {
        states: { viewReports },
        setStates,
        resetStates,
    } = useContextService();


    tableDataBackup = reportsdata

    const API = useAxios();
    const [isOpenView, setOpenView] = useState(false);
    const [selectedRow, setselectedRow] = useState({});
    const [fileData, setFileData] = useState([])
    const [totalViewReport, setTotalViewReport] = useState(false)
    const [startViewPage, setStartViewPage] = useState(null)
    const [viewSort, setViewSort] = useState(false)

    const [state, updateState] = useState({
        filters: filters,
    });
    const { SearchTerms, Search } = viewReports

    const toggleSider = async () => {
        await manval();
    }

    const handelAddCoveredEntity = async (rowData) => {
        await manvalPharmacy();
    }

    const handleonExport = () => {
        onExport()
    }

    const viewData = async (rowData, hasfilter) => {
        setselectedRow(rowData)
        if (hasfilter == true) {
            SearchTerms.ApplicationId = rowData.appID;
            SearchTerms.ReportTypeId = rowData.reportTypeID;
            SearchTerms.ReportDetail = rowData.encryptedReportDetailsID;
        }
        const tableRes = document.querySelector('.table-responsive');
        tableRes.scrollLeft = 0;
        Search.encryptedReportDetailId = rowData.encryptedReportDetailsID
        setselectedRow(rowData)
        setStartViewPage(2);
        viewReports.Search.currentPage = 1;
        viewReports.Search.pageSize = 10;
        viewReports.Search.orderBy="desc";
        viewReports.Search.order="createddate"
        setStates('viewReports', viewReports);
        await fetchFileDatails(Search);
    };

    const toggleView = () => {
        setOpenView(!isOpenView)
    };

    const fetchFileDatails = async (Search) => {
        let APIURL = ""
        if (appid == "VHBZOGZzVytDQS9HbHpuV2FMSGQ0Zz09")
        {
            APIURL = 'api/Report/medReportDetailItemGrid'
        }
        else{
           APIURL = "api/Report/phReportDetailItemGrid" 
        }
        try {
            const { data } = await API.post(APIURL, Search,
                {
                    hasDefaultURL: true,
                }
            );
            if (data) {
               // toggleView();
               setOpenView(true)
                setFileData(data.items)
                setTotalViewReport(data.totalRecords);
            }
            else {
                setFileData([])
                setOpenView(false)
                setTotalViewReport(0);
            }

        }
        catch (error) {
        }
    }


    const renderEditButton = (rowData) => {
        // if (hasPermission('EDT'))
        return (<>
            {(!["In Progress","No Data","Generate Failed", "Data Ready"].includes(rowData.statusDesc) && [1, 2, 5, 6,7,8, 9,13].includes(rowData.reportTypeID)) &&
                <Button
                    className='edit text-primary p-0 text-decoration-none'
                    color='link'
                    onClick={() => viewData(rowData)}
                    title='View Reports'
                >
                    <HoverImage
                        key='EyeIcon'
                        src={viewIcon}
                        hoverSrc={viewHoverIcon}
                        alt=''
                    />
                </Button>
            }
            <Button
                className='edit text-primary p-0 text-decoration-none'
                color='link'
                onClick={() => handleExport(rowData)}
                title="Download report">
                <HoverImage src={Download}
                    hoverSrc={DownloadHover}
                    alt='' />
            </Button>

            {rowData.statusDesc === "Uploaded" &&
                <Button
                    className='edit text-primary p-0 text-decoration-none'
                    color='link'
                    onClick={() => handleAutosendReports(rowData)}
                    title={(rowData.reportTypeID == 7 || rowData.reportTypeID == 8) ? "Download Beacon Pharmacy report" 
                    : rowData.reportTypeID == 13 ? "Download Beacon Medical report" :"Download ESP report"}>
                    <HoverImage src={Autosend}
                        hoverSrc={AutosendHover}
                        alt='' />
                </Button>
            }
        </>)
    }

    const handleExport = async (rowData) => {
        try {
            if (rowData.recordCount > 0) {
                const response = await API.get(`api/Report/download/${rowData?.encryptedReportDetailsID}`, {
                    hasDefaultURL: true,
                    responseType: 'blob'
                },
                );
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${rowData.fileName}`);
                document.body.appendChild(link);
                link.click();
            }
            else {
                toast.error('No Records Found')
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleAutosendReports = async (rowData) => {
        try {
            if (rowData.statusDesc === "Uploaded") {
                const response = await API.get(`api/Report/downloadOutFile/${rowData?.encryptedReportDetailsID}`, {
                    hasDefaultURL: true,
                    responseType: 'blob'
                },
                );
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${rowData.fileName}`);
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            console.log(error);
        }
    };


    const cellRenderEdit = (rowData) => {
        return (
            <div className='d-flex align-items-center'>
                {/* {renderConfigButton(rowData)} */}
                {renderEditButton(rowData)}
                {/* {renderCommentsButton(rowData)} */}
                {/* {renderViewButton(rowData)} */}
            </div>
        );
    };

    let mainCol = [
        {
            dataField: 'edit',
            text: 'Options',
            cellRenderer: (rowData) =>
                cellRenderEdit(rowData),
            width: 100,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
        },
        {
            dataField: 'reportName',
            text: 'Report Name',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.reportName),
        },
        {
            dataField: 'reportTypeName',
            text: 'Report Type',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.reportTypeName),
        },
        {
            dataField: 'fileName',
            text: 'File Name',
            sort: false,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.fileName),
        },
        {
            dataField: 'recordCount',
            text: 'No. of Records',
            sort: true,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.recordCount == 0 ? "0" : row.recordCount),
        },
        {
            dataField: 'statusDesc',
            text: 'Report Status',
            sort: false,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.statusDesc),
        },
        {
            dataField: 'retryCount',
            text: 'Retry Count',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.retryCount == 0 ? "0" : row.retryCount),
        },
        {
            dataField: 'dateGenerated',
            text: 'Data Generated',
            sort: true,
            width: 150,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => dateFormate(row.dateGenerated),
        },

    ];

    const setState = (state) => updateState((pre) => ({ ...pre, ...state }));

    const handleSort = (filter, hasColFilter) => {
        setState({
            filters: filter,
        });
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
            setSort(true)
        }
    };

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            setState({
                filters: filter,
            });
            onPageChange(filter);
        }
    };

    const handleViewPageChange = (filter, haveColFilter) => {
        if (haveColFilter) {
            const filterObj = cloneDeep(Search);
            filterObj.filters = [...filterObj.filters, ...filter.filters];
            filterObj.currentPage = filter.currentPage;
            filterObj.pageSize = filter.pageSize;
            viewReports.Search.currentPage = filter.currentPage;
            viewReports.Search.pageSize = filter.pageSize;
            viewReports.Search = { ...viewReports.Search };
            fetchFileDatails(filterObj);
        } else {
            if (totalViewReport > 0)
                fetchFileDatails(filter);
            viewReports.Search = { ...viewReports.Search, ...filter };
        }
        setStates('viewReports', viewReports);
    };

    const filterslist = [
        {
            filterType: "List",
            filterName: "Status",
            filterdataFiled: "statusDesc",
            filterOptions: [
                {
                    "id": "1010",
                    "label": "In Progress"
                },
                {
                   "id": "1020",
                   "label" :"Data Ready"
                },
                {
                    "id": "1030",
                    "label": "Generated",

                },
                {
                    "id": "1040",
                    "label": "Generated Failed",
                },
                {
                    "id": "1050",
                    "label": "No Data",
                },
                {
                    "id": "1060",
                    "label": "Uploaded",
                },
                {
                    "id": "1070",
                    "label": "Upload Failed",
                }
            ]
        }
    ]

    const onHandelFilterChange = (filter, hasColFilter) => {
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
        filters.currentPage = 1
    }

    return (
        <div>
            {/* {loading&&<Loader opacity={0.01}color='black'/>} */}
            <div className="d-flex justify-content-between section-devider-border pb-2">
                <h3 className='font-20'>Search Results
                    {totalSize > 0 &&
                        <span className='f-18 text-primary font-weight-700 ms-1'>({totalSize})</span>}
                </h3>
                <span style={{ cursor: "pointer" }} onClick={toggleSider}>
                    <img collapseSider src={!collapseSider ? collapse : collapseclose} className="" />
                </span>
            </div>
            <div>
                <Filters filterslist={filterslist}
                    onHandelFilterChange={onHandelFilterChange}
                    filters={filters}
                    onSearch={onSearch}
                    filtershow={filtershow}
                    setFilterShow={setFilterShow}
                    setStartPage={setReportStartPage}
                    data={reportsdata}
                    fetchReports={fetchReports}
                    selectedValues={selectedValues}
                    setSelectedValues={setSelectedValues}
                    totalRecords={totalSize}
                    ceid={ceid}
                    exportDisabled
                // resetFilter={resetFilter}
                //setResetFilter={setResetFilter} 
                />
            </div>
            <div
                className='table-card scroll-table position-relative border-0 rounded pt-0'
                fixed-height={(reportsdata && reportsdata.length > 0) ? 'fixed-height' : 'default'}
            >

                <ReactStrapTable
                    id='configuration-table'
                    height={550}
                    fixedColumn
                    width={1200}
                    // reset={reset}
                    data={reportsdata}
                    columns={mainCol}
                    handelAddCoveredEntity={handelAddCoveredEntity}
                    onExport={handleonExport}
                    filters={filters}
                    totalRecords={totalSize}
                    pageSize={filters.pageSize}
                    currentPage={filters.currentPage}
                    hasExportPermission={false}
                    startPage={reportStartPage}
                    setStartPage={setReportStartPage}
                    // collapseSider={collapseSider}
                    isReportConfiguration={true}
                    toggleSider={toggleSider}
                    handleSort={handleSort}
                    onPageChange={onHandlePageChange}
                    onPageSizeChange={onPageSizeChange}
                    hasDefaultPagination={true}
                    sort={sort}
                    setSort={setSort}

                />
            </div>
            <Modal
                isOpen={isOpenView}
                toggle={toggleView}
                centered={true}
                className="reportModal"
            >

                <ModalHeader className="modal-title">
                    <div className="title-cancel-icon">
                        <span>{selectedRow.fileName?.replace(/\.csv$/i, '')}
                        </span>
                        <Button className="modal-title-close" onClick={toggleView}>X</Button>
                    </div>
                </ModalHeader>
                <ModalBody className='pt-0'>
                    <ViewReports 
                    rowData={selectedRow}
                     setOpenView={setOpenView}
                      fileData={fileData}
                      onPageChange={handleViewPageChange}
                      filters ={Search}
                      totalSize={totalViewReport}
                      setStartPage={setStartViewPage}
                      startPage={startViewPage}
                      sort ={viewSort}
                      setSort ={setViewSort}
                       />
                </ModalBody>
            </Modal>
        </div>
    )
}

export default ReportsTable;